<template>
  <SectionContentLayout
    content_class="contacts-duplicate-finder">
    <template #close>
      <ActionButton
          @click='onActionClose()'
          v-tooltip='"contacts.actions.close"'
          class="close"
          icon="fas fa-times-circle"
        />
    </template>

    <template #header>
        <ContentTitle title="contacts.duplicate_finder.title"/>
    </template>

    <template #content>
      <div class="form">

            <fieldset>
                <p>{{Language.say('contacts.duplicate_finder.similar_contacts')}}</p>

                <ul class="list-disc">
                    <li>{{Language.say('contacts.duplicate_finder.save_unique_contact')}}</li>
                    <li>{{Language.say('contacts.duplicate_finder.add_unique_contact')}}</li>
                </ul>

                <p class="bottom-space"><strong>{{Language.say('contacts.duplicate_finder.alert1')}}</strong> {{Language.say('contacts.duplicate_finder.alert2')}}</p>


                <div class="contact"
                    v-for="(contact, index) in contacts_emails_items"
                    :key="'cn_d_' + index">
                    <div class="control-group">
                        <ul class="control check-group">
                            <li>
                                <input
                                  type="checkbox"
                                  :id="`ctc_selected_${index}`"
                                  :checked="contact.id in contacts_selection.index"
                                  @change="onToggleContactSelection(contact)">
                                <label :for="`ctc_selected_${index}`"></label>
                            </li>
                        </ul>
                        <ActionButton
                          icon='fas fa-trash-alt' class="clear" v-tooltip='"Apagar contacto"'
                          @click="onDeleteContact(contact)" />
                    </div>
                    <p v-if="contact.name">
                        <small>{{Language.say('contacts.form.name')}}</small>
                        <span>{{contact.name}}</span>
                    </p>
                    <p v-if="contact.email">
                        <small>{{Language.say('contacts.form.email')}}</small>
                        <span><a href="">{{contact.email}}</a></span>
                    </p>
                    <p v-if="contact.mobile_phone">
                        <small>{{Language.say('contacts.form.mobile_phone')}}</small>
                        <span><a href="">{{contact.mobile_phone}}</a></span>
                    </p>
                    <p v-if="contact.home_address">
                        <small>{{Language.say('contacts.form.home_address')}}</small>
                        <span>{{contact.home_address}}</span>
                    </p>
                    <p v-if="contact.company">
                        <small>{{Language.say('contacts.form.company')}}</small>
                        <span>{{contact.company}}</span>
                    </p>
                    <p v-if="contact.birth_date">
                        <small>{{Language.say('contacts.form.birthday')}}</small>
                        <span>{{contact.birth_date}}</span>
                    </p>
                    <p v-if="contact.notes">
                        <small>{{Language.say('contacts.form.notes')}}</small>
                        <span>{{contact.notes}}</span>
                    </p>
                </div>
            </fieldset>

            <div class="submit-desktop">
                <ActionButton icon="fas fa-save" c
                  text="contacts.duplicate_finder.button_independent"
                  @click="onSetContactIndependent" />
                <ActionButton class="main-action"
                  icon="far fa-address-card"
                  text="contacts.duplicate_finder.button_add"
                  @click="onActionSubmit" />
            </div>


        </div>
    </template>
  </SectionContentLayout>
</template>

<script setup>
  import { onBeforeMount, defineProps, ref}      from 'vue'
  import { onMounted, onUnmounted, defineEmits } from 'vue';
  import ActionButton               from '@/vue/Elements/Buttons/ActionButton.vue';
  import SectionContentLayout       from '@/vue/Layouts/Sections/SectionContentLayout.vue';
  import Language                   from '@/js/Shared/Language/Language';
  import ContentTitle               from '@/vue/Elements/Content/ContentTitle.vue';
  import ContactsSelectionCollection from '@/js/Contacts/Collections/ContactsSelectionCollection';
  import ContactsController from '@/js/Contacts/ContactsController';

  const props = defineProps({
    contacts_duplicates_list: {},
    contacts_view: {},
    contacts_selection: {}
  });

  const emit = defineEmits([
    'contactsDuplicatesListClose', 'contactsDuplicatesSubmit'
  ]);

  onBeforeMount(() => {
    setContactEmailsItems();
    setContactSelection();
  });

  onMounted(() => {
    contacts_controller.broadcaster.on('contacts-deleted', onContactsDeleted);
  })

  onUnmounted(() => {
    contacts_controller.broadcaster.destroy('contacts-deleted', onContactsDeleted)
  });

  const contacts_emails_items = ref();
  const contacts_controller = ContactsController;

  const onActionClose = () => {
    emit('contactsDuplicatesListClose');
  }

  const onActionSubmit = () => {
    emit('contactsDuplicatesSubmit')
  }

  const onDeleteContact = (contact) => {
    const simple_selection = new ContactsSelectionCollection();
    simple_selection.add(contact);
    props.contacts_view.openContactsDelete(simple_selection, 'contacts-deleted');
  }

  const onContactsDeleted = (contacts) => {
    props.contacts_duplicates_list.removeSelectedContactDuplicates(contacts, props.contacts_duplicates_list.email_selected);
    props.contacts_selection.deleteContactsFromArray(contacts);
  }

  const onToggleContactSelection = (contact) => {
    props.contacts_selection.toggle(contact.id, contact);
  }

  const onSetContactIndependent = () => {
    props.contacts_duplicates_list.removeEmailFromDuplicates(props.contacts_duplicates_list.email_selected);
    emit('contactsDuplicatesListClose');
  }

  const setContactSelection = () => {
    props.contacts_selection.addItems(contacts_emails_items.value);
  }

  const setContactEmailsItems = () => {
    const email_selected = props.contacts_duplicates_list.email_selected;
    contacts_emails_items.value = props.contacts_duplicates_list.duplicates[email_selected].items;
  }
</script>